import { render, staticRenderFns } from "./courseapplication.vue?vue&type=template&id=0f81c4c0&scoped=true"
import script from "./courseapplication.vue?vue&type=script&lang=js"
export * from "./courseapplication.vue?vue&type=script&lang=js"
import style0 from "./courseapplication.vue?vue&type=style&index=0&id=0f81c4c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81c4c0",
  null
  
)

export default component.exports